import React from 'react'
import { UserContext } from '../../context/user-context'
import { useParams } from 'react-router'
import { useState } from 'react'
import { useContext } from 'react'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { Breadcrumb } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import EventsTicketContainer from '../../components/events/tickets-container'
import { Button } from 'react-bootstrap'
import { useEffect } from 'react'
import axios from 'axios'
import EventSidebarLinks from '../../components/events/sidebar-links'

export default function EventTickets() {
  const breadcrumbs = useBreadcrumbs()
  const { userToken, user } = useContext(UserContext)
  const { event_id } = useParams()
  const [eventTickets, setEventsTickets] = useState([])
  const [name, setName] = useState('')
  const [event, SetEvent] = useState({})
  const [updating, setUpdating] = useState(false)
  const [loadingEvents, setLoadingEvents] = useState(true)

  useEffect(() => {
    getEvent()
  }, [])

  const getEvent = () => {
    setLoadingEvents(true)
    axios
      .get(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/' + event_id, {
        headers: {
          Authorization: 'Basic ' + btoa(user.user_login + ':' + userToken),
        },
      })
      .then((res) => {
        const event = res.data.event
        SetEvent(event)
        setName(event.name)
        let _tickets = []
        for (let i = 0; i < res.data.tickets.length; i++) {
          const _ticket = res.data.tickets[i]
          _tickets.push({
            name: _ticket.name,
            price: parseFloat(_ticket.price),
            quantity: _ticket.max_qty,
            unlimitedTicketsQuantity: _ticket.max_qty === '' ? true : false,
            description: _ticket.description,
          })
        }
        console.log(_tickets)
        setEventsTickets(_tickets)
      })
      .catch((err) => {
        console.log(err.message)
        alert('Error!! Check Logs.')
      })
      .finally(() => {
        setLoadingEvents(false)
      })
  }

  const updateEvent = () => {
    const form = new FormData()
    form.set('eventTickets', JSON.stringify(eventTickets))
    // console.log(form)
    const _user = JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_LOCALSTOAGE_KEY))
    const _userToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_LOCALSTOAGE_KEY)
    setUpdating(true)
    const post_status = form.get('status')
    axios
      .post(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/' + event_id + '/tickets', form, {
        headers: {
          'Authorization': 'Basic ' + btoa(_user.user_login + ':' + _userToken),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        console.log(res.data)
        // window.location.reload();
      })
      .catch((err) => {
        console.log(err.message)
      })
      .finally(() => {
        setUpdating(false)
      })
  }

  if (loadingEvents) {
    return (
      <Container>
        <section className='create-event-ticket'>
          <p>Loading...</p>
        </section>
      </Container>
    )
  }
  return (
    <Container
      fluid
      className='p-relative'>
      <EventSidebarLinks event={event} />
      <Container className='event-stats-container py-3'>
        <section className='create-event-ticket'>
          <Breadcrumb>
            {breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
              breadcrumb = key === '/events/' + event_id ? name : breadcrumb
              return (
                <Breadcrumb.Item
                  key={index}
                  href={key}>
                  {breadcrumb}
                </Breadcrumb.Item>
              )
            })}
          </Breadcrumb>
          <div className='p-relative'>
            <div className='text-center'>
              <h3>Event Tickets</h3>
              <EventsTicketContainer
                eventTickets={eventTickets}
                setEventsTickets={setEventsTickets}
              />
              <Button
                variant='primary'
                className='mt-3'
                disabled={eventTickets.length === 0 || updating}
                onClick={() => {
                  updateEvent()
                }}>
                Update Tickets
              </Button>
            </div>
          </div>
        </section>
      </Container>
    </Container>
  )
}
